import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "save-story-filled-3wdSR",
  "use": "save-story-filled-3wdSR-usage",
  "viewBox": "0 0 15 18",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 15 18\" id=\"save-story-filled-3wdSR\"><path fill-rule=\"evenodd\" d=\"M13.64 0H1.36a1.31 1.31 0 0 0-.516.105C.328.305 0 .785 0 1.313v15.105c0 .527.328 1.008.844 1.207.164.07.34.105.515.105.364 0 .704-.14.973-.386L7.5 12.375l5.168 4.969c.27.246.61.375.973.375.175 0 .351-.024.515-.094.516-.2.844-.68.844-1.207V1.313c0-.528-.328-1.008-.844-1.208A1.31 1.31 0 0 0 13.641 0z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol